import { AutocompleteWithQuery } from "@knowfully/ui.common";
import { AutocompleteWithQueryProps } from "@knowfully/ui.common/components/AutocompleteWithQuery";
import useGlobalContext from "hooks/globalData";
import { useIntl } from "react-intl";
import { useQuery } from "react-query";
import { SkuFormat } from "services/organizationPortalClient";
import contextStore from "stores/contextStore";

type SelectCertificatesFormatProps = Omit<
  AutocompleteWithQueryProps<SkuFormat>,
  "fetchedData" | "failMessage" | "labelField"
>;

export default function SelectSkuFormat({
  ...rest
}: Readonly<SelectCertificatesFormatProps>) {
  const { formatMessage: t } = useIntl();
  const { catalogService } = useGlobalContext();
  const { organization } = contextStore.useState();

  const data = useQuery(["sku-formats", organization?.id], () =>
    catalogService.getSkuFormats()
  );

  return (
    <AutocompleteWithQuery
      {...rest}
      size="small"
      labelField="plainTextName"
      fetchedData={data}
      label={t({ id: "format" })}
      failMessage={t({ id: "fetchError" })}
    />
  );
}
